/**
 * Checks whether an AccountMarketingMaterial has all print assets.
 *
 * @param {Object} accountMarketingMaterial The AccountMarketingMaterial.
 * @returns {*}
 */
export const accountMarketingMaterialHasAssets = accountMarketingMaterial => {
  return (
    accountMarketingMaterial?.pdf_url && accountMarketingMaterial?.image_url
  );
};

/**
 * Returns the active custom design (AlbumFolderMarketingMaterialAsset join
 * record) of a given marketing material type for an albumFolder, if any.
 * Records come ordered by created_at DESC, so the first match wins.
 *
 * @param {Object} albumFolder The albumFolder with marketing_material_assets.
 * @param {String} marketingMaterialType The marketing material type.
 * @returns {Object|null}
 */
export const getCustomDesignForType = (albumFolder, marketingMaterialType) => {
  return (
    (albumFolder?.marketing_material_assets?.records ?? []).find(
      record =>
        record?.marketing_material_asset?.marketing_material_type ===
        marketingMaterialType,
    ) ?? null
  );
};
